import React, { useState, useRef, useCallback } from "react";
import { SubmitHandler, FormHandles } from "@unform/core";
import { Form } from "@unform/web";
import { useValidation, useTranslation } from "hooks";
import { translations } from "./translations";
import * as S from "./styles";

import { Modal } from "components/shared";
import { Input } from "components/shared/Form";
import { useFilters } from 'hooks/useFilters';

export const FilterSupplier: React.FC = () => {
  const formRef = useRef<FormHandles>(null);
  const { handleFormErrors } = useValidation();
  const { getTranslation } = useTranslation(translations);
  const [modalOpen, setModalOpen] = useState<boolean>(false);
  const [cleanShow, setCleanShow] = useState<boolean>(false);

  const { setFilter } = useFilters("suppliers", { formRef });

  const handleSubmit = useCallback<SubmitHandler>(
    async (data: any) => {
      try {
        const cpfCnpj = data.cnpj
          ?.toUpperCase()
          .replace(/[^A-Z0-9]/g, '');

        setFilter({ ...data, cnpj: cpfCnpj });

        setCleanShow(true);
        setModalOpen(false);
      } catch (error) {
        handleFormErrors(error, formRef);
      }
    },
    [setFilter, handleFormErrors]
  );

  const handleFilterClean = useCallback(() => {
    if (formRef.current) {
      formRef.current.setFieldValue("code", "");
      formRef.current.setFieldValue("trade_name", "");
      formRef.current.setFieldValue("cnpj", "");
  

      const clean = {
        code: "",
        trade_name: "",
        cnpj: "",
      };

      setFilter(clean);
    }

    setCleanShow(false);
    setModalOpen(false);
  }, [setFilter]);

  const renderButtonCleanFilter = () => {
    if (cleanShow) {
      return (
        <S.ButtonMini btStyle="dark" onClick={handleFilterClean}>
          {getTranslation("limparFiltro")}
        </S.ButtonMini>
      );
    }
  };

  return (
    <S.Container>
      <Modal isOpen={modalOpen}>
        <S.ModalContainer>
          <S.Header>
            <S.IconFilter />
            <S.Title>{getTranslation("filtrar")}</S.Title>
          </S.Header>
          <Form placeholder={""} ref={formRef} onSubmit={handleSubmit}>
            <S.FormRow>
              <Input name="code" label={getTranslation("codigo")} />
              <Input name="cnpj" label={getTranslation("cnpj")} />
            </S.FormRow>

            <S.FormRow>
              <Input name="trade_name" label={getTranslation("nomeFantasia")} />
 
            </S.FormRow>

            <S.ButtonsWrapper>
              <S.Button
                btStyle="cancel"
                onClick={() => setModalOpen(false)}
                type="button"
              >
                {getTranslation("fechar")}
              </S.Button>
              <S.Button
                btStyle="danger"
                type="button"
                onClick={handleFilterClean}
              >
                {getTranslation("limparFiltro")}
              </S.Button>
              <S.Button type="submit">{getTranslation("filtrar")}</S.Button>
            </S.ButtonsWrapper>
          </Form>
        </S.ModalContainer>
      </Modal>

      {renderButtonCleanFilter()}
      <S.ButtonFilter onClick={() => setModalOpen(true)}>
        <S.IconFilter />
      </S.ButtonFilter>
    </S.Container>
  );
};
